import { createSelector } from '@ngrx/store';
import { selectAllEntites } from '@features/referentiel/features';
import { OrganismeFormation } from '@features/referentiel/models/organisme-formation';
import * as fromMain from '@features/mes-remboursements/store/main.reducer';


const selectMesRemboursementsState = fromMain.mesRemboursementsFeature.selectMesPaiementsPageState;

export const selectMesRemboursementsRechercheFormValues = createSelector(selectMesRemboursementsState, (state) => state.recherche.value);
export const selectMesRemboursementsRechercheFormCategorie = createSelector(selectMesRemboursementsState, (state) => state.recherche.categorieDossier);
export const selectMesRemboursementsRechercheFormQuerySiret = createSelector(selectMesRemboursementsState, (state) => state.recherche.querySiret);
export const selectMesRemboursementsRechercheFormErrors = createSelector(selectMesRemboursementsState, (state) => state.recherche.errors);
export const selectMesRemboursementsDisplayDispositif = createSelector(selectMesRemboursementsState, (state) => state.recherche.displayDispositif);
export const selectMesRemboursementsDisplayStatus = createSelector(selectMesRemboursementsState, (state) => state.recherche.displayStatus);
export const selectMesRemboursementsDisplayNumeroDossier = createSelector(selectMesRemboursementsState, (state) => state.recherche.displayNumeroDossier);
export const selectMesRemboursementsDisplaySiret = createSelector(selectMesRemboursementsState, (state) => state.recherche.displaySiret);
export const selectMesRemboursementsResetDone = createSelector(selectMesRemboursementsState, (state) => state.recherche.resetDone);
export const selectMesRemboursementsKeepHistory = createSelector(selectMesRemboursementsState, (state) => state.recherche.keepHistory);

export const selectFilteredAndLimitedEntitesSiretFromQuery = (maxSize: number) => createSelector(
    selectAllEntites,
    selectMesRemboursementsRechercheFormQuerySiret,
    (entites: OrganismeFormation[], query: string) => {
        let filteredEntites = entites;

        if (query && query.length > 0) {
            filteredEntites = entites.filter(entite => entite.siret.startsWith(query));
        }

        return filteredEntites.slice(0, maxSize).map(entite => entite);
    }
);

export const selectFilteredAndLimitedEntitesSiretFromQueryCount = createSelector(
    selectAllEntites,
    selectMesRemboursementsRechercheFormQuerySiret,
    (entites: OrganismeFormation[], query: string) => {
        let filteredEntites = entites;

        if (query && query.length > 0) {
            filteredEntites = entites.filter(entite => entite.siret.startsWith(query));
        }

        return filteredEntites.length;
    }
);
